import { deepClone } from '@/utils/commonUtils'

// BASE_EFFECTIVE_DATE("JCXX001", "生效日期", RuleEnums.VALID_DATE, ComponentTypeEnums.DATE_PICK),

//     BUYER_SEX("TBRXX001", "性别", RuleEnums.BUYER_SEX, ComponentTypeEnums.RADIO),

//     BUYER_BIRTHDAY("TBRXX001", "投保人出生日期", RuleEnums.BUYER_BIRTHDAY, ComponentTypeEnums.DATE_PICK),

//     INSURED_INFO("BBRXX001", "为谁投保", RuleEnums.INSURED_INFO, ComponentTypeEnums.DROP_DOWN_BOX),

//     INSURED_BIRTHDAY("BBRXX001", "被保人出生日期", RuleEnums.INSURED_BIRTHDAY, ComponentTypeEnums.DATE_PICK),

//     INSURED_SEX("BBRXX001", "被保人性别", RuleEnums.INSURED_SEX, ComponentTypeEnums.RADIO),

//     INSURED_SOCIAL("BBRXX001", "是否有社保", RuleEnums.INSURED_SOCIAL, ComponentTypeEnums.RADIO),

//     INSURANCE_LENGTH("BZFA001", "保障期限", RuleEnums.INSURANCE_LENGTH, ComponentTypeEnums.CHECK_BOX),

//     PAY_LENGTH("BZFA001", "缴费期限", RuleEnums.PAY_LENGTH, ComponentTypeEnums.CHECK_BOX),

//     PAY_FREQUENCY("BZFA001", "缴费频率", RuleEnums.PAY_FREQUENCY, ComponentTypeEnums.CHECK_BOX),

//     BASE_DESTINATION("JCXX001", "目的地", null, ComponentTypeEnums.CASCADE),

//     BUYER_NAME("TBRXX001", "姓名", null, ComponentTypeEnums.TEXT_BOX),

//     BUYER_CONTACT_ADDRESS("TBRXX001", "联系地址", null, ComponentTypeEnums.CASCADE),

//     BUYER_DETAIL_ADDRESS("TBRXX001", "详细地址", null, ComponentTypeEnums.TEXT_BOX),

//     BUYER_CARD_TYPE("TBRXX001", "证件类型", null, ComponentTypeEnums.RADIO),

//     BUYER_CARD_CODE("TBRXX001", "证件号", null, ComponentTypeEnums.TEXT_BOX),

//     BUYER_CARD_PERIOD_TYPE("TBRXX001", "证件有效期类型", null, ComponentTypeEnums.RADIO),

//     BUYER_CARD_PERIOD("TBRXX001", "证件有效期止期", null, ComponentTypeEnums.DATE_PICK),

//     BUYER_JOB_GRADE("TBRXX001", "职业类别", null, ComponentTypeEnums.CASCADE),

//     BUYER_MOBILE("TBRXX001", "手机号", null, ComponentTypeEnums.TEXT_BOX),

//     BUYER_EMAIL("TBRXX001", "邮箱", null, ComponentTypeEnums.TEXT_BOX),

//     BUYER_SOCIAL("TBRXX001", "是否有社保", RuleEnums.INSURED_SOCIAL, ComponentTypeEnums.RADIO),

//     INSURED_NAME("BBRXX001", "姓名", null, ComponentTypeEnums.TEXT_BOX),

//     INSURED_CONTACT_ADDRESS("BBRXX001", "联系地址", null, ComponentTypeEnums.CASCADE),

//     INSURED_DETAIL_ADDRESS("BBRXX001", "详细地址", null, ComponentTypeEnums.TEXT_BOX),

//     INSURED_CARD_TYPE("BBRXX001", "证件类型", null, ComponentTypeEnums.RADIO),

//     INSURED_CARD_CODE("BBRXX001", "证件号", null, ComponentTypeEnums.TEXT_BOX),

//     INSURED_CARD_PERIOD_TYPE("BBRXX001", "证件有效期类型", null, ComponentTypeEnums.RADIO),

//     INSURED_CARD_PERIOD("BBRXX001", "证件有效期止期", null, ComponentTypeEnums.DATE_PICK),

//     INSURED_JOB_GRADE("BBRXX001", "职业类别", null, ComponentTypeEnums.CASCADE),

//     INSURED_MOBILE("BBRXX001", "手机号", null, ComponentTypeEnums.TEXT_BOX),

//     INSURED_EMAIL("BBRXX001", "邮箱", null, ComponentTypeEnums.TEXT_BOX),

//     BENEFICIARY_TYPE("SYRXX001", "受益人类型", null, ComponentTypeEnums.RADIO),

//     BENEFICIAL_ORDER("SYRXX001", "受益人顺序", null, ComponentTypeEnums.RADIO),

//     BENEFICIAL_PROPORTION("SYRXX001", "受益比例", null, ComponentTypeEnums.TEXT_BOX),

//     INSURANCE_COLLECTION_AGE("BZFA001", "领取年龄", null, ComponentTypeEnums.CHECK_BOX),

//     INSURANCE_BASIC_AMOUNT("BZFA001", "基本保额", null, ComponentTypeEnums.TEXT_BOX),

//     INSURANCE_PAY_AMOUNT("BZFA001", "保费", null, ComponentTypeEnums.CHECK_BOX),

//     INSURANCE_COUNT("BZFA001", "购买份数", null, ComponentTypeEnums.STEPPER),

//     URGENCY_CONTACT("JJLXR001", "姓名", null, ComponentTypeEnums.TEXT_BOX),

//     URGENCY_CONTACT_MOBILE("JJLXR001", "手机号", null, ComponentTypeEnums.TEXT_BOX),

//     RENEWAL_BANK("XQJFXX001", "开户银行", null, ComponentTypeEnums.CASCADE),

//     RENEWAL_CARD_HOLDER("XQJFXX001", "持卡人", null, ComponentTypeEnums.TEXT_BOX),

//     RENEWAL_ACCOUNT("XQJFXX001", "银行账号", null, ComponentTypeEnums.TEXT_BOX),

//     RENEWAL_ADDRESS("XQJFXX001", "银行地址", null, ComponentTypeEnums.CASCADE),


//     INSURANCE_ELEMENT("INSURANCE_RULE", "险种元素", RuleEnums.INSURANCE_RULE, ComponentTypeEnums.RADIO),

//     DUTY_ELEMENT("DUTY_RULE", "责任规则", RuleEnums.DUTY_RULE, ComponentTypeEnums.RADIO),
//  模块对应
let model = {
    'JCXX001': '基础信息',
    'TBRXX001': '投保人信息',
    'BBRXX001': '被保人信息',
    'SYRXX001': '受益人信息',
    'BZFA001': '保障方案',
    'JJLXR001': '紧急联系人',
    'XQJFXX001': '续期缴费信息',
}

// 组件类型 除单选框和文本框外其他暂不兼容
export const elementType = {
    'DXK001': 'elementRadio',   //'单选框',  
    'DXK002': 'elementCheck',   //'多选框',  
    'WBK001': 'elementInput',     // '文本框' 
    // 'XLK001': 'elementSelect',   //'下拉框', 
    // 'RQXZQ001':'elementDataTime',   //'日期选择器', 
    // 'JL001': 'elementji',    //'级联', 
    // 'BJQ001': 'elementbu',   //'步进器', 
    // 'DHWB001': 'elementTextarea',   //'多行文本', 
    // 'DTSC001':'elementImgLoad'  //'单图上传', 

}

// 组件（input，radio，checkbox） 参数格式化
export const format = (element, moduleCode) => {
    let obj;
    const pageDetail = JSON.parse(deepClone(element.pageDetail))
    obj = {
        value: element.defaultValue || '',    //默认值
        rules: {
            max: pageDetail.writeLimit || '',  //最大值
            inputLimit: pageDetail.inputLimit || '', //输入规则
        },
        elementCode: element.elementCode,    //
        elementEnums: element.elementEnums, //
        ruleEnums: element.ruleEnums,    //
        elementName: element.elementName,  // 组件name
        showName: element.showName,  // 组件展示name
        isCount: element.isCount,    //是否为算费因子
        placeholder: pageDetail.defaultHint || '', //提示文字
        moduleCode: moduleCode,  // 所属哪个模块
        componentTypeCode: element.componentTypeCode, // 组件类型
        isRequired: element.isRequired,   //是否必填 (可根据用户选择修改为true/false)
        defaultisRequired: element.isRequired,   //是否必填默认值
        list: pageDetail.list || [],  // 单选/多选的list
        freeAmount: element.freeAmount || '', //多选框附加服务的协议
        freeRate: element.freeRate || '', //多选框附加服务的协议
        desc: element.desc || '', //多选框附加服务的协议
        readonly: element.readonly || false, //是否只读
    }
    return obj
}


//赠险参数格式化
export const PresentFormat = (pageData, fromData) => {
    let obj;
    const pageDetail = deepClone(pageData)
    const fromDetail = deepClone(fromData)
    obj = {
        bannerUrl: pageDetail.bannerUrl || '',  // banner图 
        bgColor: pageDetail.bgColor || '',   //背景色 
        processTips: pageDetail.processTips || '', // 投保流程弹框内容
        companyDetail: pageDetail.companyDetail || '', // 详情
        insureBtnColor: pageDetail.insureBtnColor || '', // 按钮颜色
        insureBtnName: pageDetail.insureBtnName || '',   //按钮文字
        schemeServiceList: pageDetail.schemeServiceList || [], //服务详情
        productCode: pageDetail.productCode || '', //产品CODE
        commodityName: pageDetail.commodityName || '',	// 商品名称
        serviceDetail: pageDetail.serviceDetail || '', //填单标题右侧文案
        topTitle: pageDetail.topTitle || '', // title标题
        featureUrl: pageDetail.featureUrl, // 产品特色
        isFollow: fromDetail.isFollow || undefined, //是否为赠险
        modules: fromDetail.modules,
        schemeList: fromDetail.schemeList || [], //赠险方案列表
        materielMap: fromDetail.materielMap || [], //协议
        formTitle: fromDetail.formTitle || '',  //填单标题
        schemes: fromDetail.schemes || [], // 方案列表
        keywordList: fromDetail.keywordList || [], //弹框气泡词
        schemeTitle: fromDetail.schemeTitle, // 方案标题
        followOrderPrice: fromDetail.followOrderPrice || '', //价格
        channelType: pageDetail.channelType || '', //渠道

    }
    return obj
}


